import { Time } from 'lightweight-charts'
import DrawingBase from './drawing.base'
import { LabelAxisViewConfig } from './drawing.interface'
import DrawingPaneAxisView from './drawing.paneAxisView'
import DrawingPaneView from './drawing.paneView'
import DrawingAxisLabelView, { DrawingAxisLabelViewOptions } from './drawing.axisLabelView'


export type DrawingPaneAxisViewManagerOptions = {
    drawing: DrawingBase<any, any, any>
}

class DrawingPaneAxisViewManager {
    drawing: DrawingBase<any, any, any>
    priceAxisViewConfig: Record<string, LabelAxisViewConfig<number>> = {}
    timeAxisViewConfig: Record<string, LabelAxisViewConfig<Time>> = {}
    priceAxisPaneViews: DrawingPaneView[] = []
    timeAxisPaneViews: DrawingPaneView[] = []
    priceAxisLabels: DrawingAxisLabelView[] = []
    timeAxisLabels: DrawingAxisLabelView[] = []

    constructor(options: DrawingPaneAxisViewManagerOptions) {
        this.drawing = options.drawing
    }

    updateAxisConfigs() {
        if (this.drawing.getAvailableSettings().length && !Object.values(this.drawing._settings).length) return
        const priceConfigs = this.drawing.getPriceAxisLabelPoints()
        const newPriceViewIds: string[] = []
        priceConfigs.forEach(v => {
            newPriceViewIds.push(v.id)
            this.priceAxisViewConfig[v.id] = { ...v }
        })
        const priceViewIds = this.priceAxisPaneViews.map(v => v.id)
        const priceLabelIds = this.priceAxisLabels.map(v => v.id)
        let priceViews = this.priceAxisPaneViews
        let priceLabels = this.priceAxisLabels
        let removedPriceViewIds = priceViewIds.filter(v => newPriceViewIds.indexOf(v) === -1)

        priceConfigs.forEach((p) => {
            if (priceViewIds.indexOf(p.id) === -1) {
                priceViews = [...priceViews, new DrawingPaneAxisView({
                    id: p.id,
                    drawing: this.drawing,
                    horizontal: false
                })]
            }
            ['p1', 'p2'].forEach((l) => {
                const labelId = `${p.id}-${l}`
                if (priceLabelIds.indexOf(labelId) === -1) {
                    priceLabels = [...priceLabels, new DrawingAxisLabelView({
                        id: labelId,
                        configId: p.id,
                        drawing: this.drawing,
                        horizontal: false,
                        point: l as DrawingAxisLabelViewOptions['point']
                    })]
                }
            })
        })

        this.priceAxisPaneViews = removedPriceViewIds.length ? priceViews.filter(v => removedPriceViewIds.indexOf(v.id) === -1) : priceViews
        this.priceAxisLabels = removedPriceViewIds.length ? priceLabels.filter(v => removedPriceViewIds.indexOf(v.configId) === -1) : priceLabels

        const timeConfigs = this.drawing.getTimeAxisLabelPoints()
        const newTimeViewIds: string[] = []
        timeConfigs.forEach(v => {
            newTimeViewIds.push(v.id)
            this.timeAxisViewConfig[v.id] = { ...v }
        })

        const timeViewIds = this.timeAxisPaneViews.map(v => v.id)
        const timeLabelIds = this.timeAxisLabels.map(v => v.id)
        let timeViews = this.timeAxisPaneViews
        let timeLabels = this.timeAxisLabels
        let removedTimeViewIds = timeViewIds.filter(v => newTimeViewIds.indexOf(v) === -1)

        timeConfigs.forEach((p) => {
            if (timeViewIds.indexOf(p.id) === -1) {
                timeViews = [...timeViews, new DrawingPaneAxisView({
                    id: p.id,
                    drawing: this.drawing,
                    horizontal: true
                })]
            }
            ['p1', 'p2'].forEach((l) => {
                const labelId = `${p.id}-${l}`
                if (timeLabelIds.indexOf(labelId) === -1) {
                    timeLabels = [...timeLabels, new DrawingAxisLabelView({
                        id: labelId,
                        configId: p.id,
                        drawing: this.drawing,
                        horizontal: true,
                        point: l as DrawingAxisLabelViewOptions['point']
                    })]
                }
            })
        })
        this.timeAxisPaneViews = removedTimeViewIds.length ? timeViews.filter(v => removedTimeViewIds.indexOf(v.id) === -1) : timeViews
        this.timeAxisLabels = removedTimeViewIds.length ? timeLabels.filter(v => removedTimeViewIds.indexOf(v.configId) === -1) : timeLabels
    }

    getPaneAxisViewConfig(id: string): LabelAxisViewConfig<any> {
        return this.priceAxisViewConfig[id] || this.timeAxisViewConfig[id]
    }

    getPriceAxisPaneViews() {
        return this.priceAxisPaneViews
    }

    getTimeAxisPaneViews() {
        return this.timeAxisPaneViews
    }

    getPriceAxisLabels(): DrawingAxisLabelView[] {
        return this.priceAxisLabels
    }

    getTimeAxisLabels(): DrawingAxisLabelView[] {
        return this.timeAxisLabels
    }
}


export default DrawingPaneAxisViewManager